

















































































import Component from "vue-class-component";
import axios from "@/plugins/axios";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import ErrorMixin from "@/mixins/errorMixins";
import { Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Login extends mixins(MobileMixin, ErrorMixin) {
  public login: string = "";
  public password: string = "";
  public loading: boolean = false;
  public loginType: string = "none";
  public finger: boolean = false;
  public ip: string = "";
  public show: boolean = false;

  public openKeyboard = false;

  public mounted() {
    // console.log(localStorage.ip)
    document.addEventListener(
      "focusout",
      (e: any) => (this.openKeyboard = false)
    );

    document.addEventListener("focusin", (e: any) => {
      if (this.isMobile()) {
        this.openKeyboard = true;
      }
    });

    // console.log(this.user);
    if (this.user && this.user.login && localStorage.token !== undefined) {
      this.login = this.user.login;

      // if (!this.isMobile()) {
      this.directLogin(this.login, localStorage.token);
      // }
    }

    if (this.client === "TOTAL") {
      // Passe la langue par défaut en DE
      this.$i18n.locale = "de";
    }
    /* if (window.Fingerprint) {
        window.Fingerprint.isAvailable(this.isAvailableSuccess, this.isAvailableError);
      }
      document.addEventListener("deviceready", function () {
        // console.log(cordova.plugins)
      // cordova.plugins.SitewaertsDocumentViewer is now available
      }, false);
      console.log(this.login); */
  }

  /**
   * Mets à jour la langue dans le store
   * @param newVal nouvelle langue
   */
  @Watch("$i18n.locale", { immediate: true, deep: true })
  public onLanguageChange(newVal: string) {
    this.$store.dispatch("login/setLanguage", newVal);
    this.$vuetify.lang.current = newVal;
  }

  /**
   * methode permettant de declancher le login au click sur entrée
   */
  public logMe(evt: any) {
    if (evt.keyCode === 13) {
      this.logMeIn();
    }
  }

  /**
   * methode de login a l'application
   */
  public async logMeIn() {
    const login = this.login;
    const password = this.password;
    this.$store.dispatch("login/setLoading", true);
    await this.$store
      .dispatch("login/login", { login, password })
      .then(async (response: any) => {
        // this.$store.dispatch("login/getSites", this.client);
        await this.getAllReports();
        this.getTracker();
        if (this.$store.getters.getGlobal) {
          this.$router.push("rapports");
        } else {
          this.$router.push("home");
        }

        if (this.$store.getters.getGlobal) {
          this.$store.dispatch("login/getSirets", this.client);
        }
        if (this.client !== "BK") {
          this.$store.dispatch("login/getEnseignes", this.client);
        }
      })
      .catch((error: any) => {
        console.log(error);
        const message =
          /* error.message ? error.message : */ this.$t(
            "badCredentials"
          ).toString();
        this.setErrorFromTxt(message);
      });
    this.$store.dispatch("login/setLoading", false);
  }

  public async getTracker() {
    await this.$store
      .dispatch("rapport/getTracker")
      .then((rapports) => {
        // console.log(rapports);
      })
      .catch((error: any) => {
        this.stopLoading();
        this.logout();
        // console.log(error)
        this.setErrorFromTxt(this.$t("ErrorGettingAllReport").toString());
      });
  }

  public async getAllReports() {
    await this.$store
      .dispatch("rapport/getAllReports")
      .then((rapports) => {
        // console.log(rapports);
      })
      .catch((error: any) => {
        this.stopLoading();
        this.logout();
        // console.log(error)
        this.setErrorFromTxt(this.$t("ErrorGettingAllReport").toString());
      });
  }
  public resetPassword() {
    let url = "login/reinitPass";
    let payload: string | { login: string; locale: string };
    if (this.client === "TOTAL") {
        url = "login/reinitPassTotal";
        payload = {
            login: this.login,
            locale: this.$i18n.locale
        };
    } else {
        payload = this.login;
    }
    this.$store.dispatch(url, payload).then(
        (response: any) => {
            this.setSuccess(this.$t("seeUrMail").toString());
        },
        (error: any) => {
            if (error.status === 400) {
                this.setErrorFromTxt(this.$t("userNull").toString());
            } else {
                this.setErrorFromTxt(this.$t("error").toString());
            }
        }
    );
    /*$http.get(URLExports + "reinit/sendReinitMail?user=" + $scope.auth.login).then(function (data) {
      var checkUrMail = gettextCatalog.getString("checkUrMail");
      var toast = $mdToast.simple()
        .textContent(checkUrMail)
        .action('OK')
        .highlightAction(false)
        .hideDelay(6000)
        .theme('okToast')
        .position("top right");
      $mdToast.show(toast).then(function () {
        $mdToast.hide();
      });
    }, function (data) {
      var saveError;
      if (data.status === 500) {
        if (data.data.exception === "java.lang.IllegalArgumentException") {
          saveError = gettextCatalog.getString("unknownLogin");
        } else if (data.data.exception === "org.springframework.mail.MailSendException") {
          saveError = gettextCatalog.getString("unknownEmail");
        }
        var toast = $mdToast.simple()
          .textContent(saveError)
          .action('OK')
          .highlightAction(false)
          .hideDelay(6000)
          .theme('errorToast')
          .position("top right");
        $mdToast.show(toast).then(function () {
          $mdToast.hide();
        });
      }
    });*/
  }

  public isAvailableSuccess(result: any) {
    this.loginType = result;
    // alert(result + " Available");
  }
  public isAvailableError(message: string) {
    // alert(message);
  }
  public testFace() {
    // window.Fingerprint.show({ clientId: "Fingerprint-Demo", clientSecret: "password" }, this.successCallback, this.errorCallback);
  }
  public successCallback() {
    // alert("Authentication successfull");
  }
  public errorCallback(err: any) {
    // alert("Authentication invalid " + err);
  }

  private async directLogin(login: string, token: string) {
    if (this.isMobile() && localStorage.ip !== undefined) {
      this.ip = JSON.parse(localStorage.ip);
      axios.defaults.baseURL = this.ip + "/";
      // console.log(axios.defaults);
    }
    await this.$store
      .dispatch("login/directLogin", { login, token })
      .then(async (response: any) => {
        // this.$store.dispatch("login/getSites", this.client);
        await this.getAllReports();
        this.getTracker();
        if (this.$store.getters.getGlobal) {
          this.$router.push("rapports");
        } else {
          this.$router.push("home");
        }
        if (this.$store.getters.getGlobal) {
          this.$store.dispatch("login/getSirets", this.client);
        }
        if (this.client !== "BK") {
          this.$store.dispatch("login/getEnseignes", this.client);
        }
      })
      .catch((error: any) => {
        const err = error.toString().substring(7);
        console.log(JSON.parse(err));
        this.setErrorFromTxt(this.$t("badCredentials").toString());
      });
  }

  get user() {
    return this.$store.getters["login/user"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
